import { throttle } from 'throttle-debounce';

export const headerCollapsePlugin = {
  afterRender({ updateHeaderProps, headerType, params }) {
    let collapsed;
    let lastYScrollPosition = window.scrollY;

    const handleDownDirection = ({ isOnTop, direction }) => {
      if (direction === 'DOWN' && !isOnTop && !collapsed) {
        collapsed = true;
        updateHeaderProps({ collapsed });
      }
    };

    const handleUpDirection = ({ isOnTop, isFastMove, direction }) => {
      if (direction === 'UP' && (isFastMove || isOnTop) && collapsed) {
        collapsed = false;
        updateHeaderProps({ collapsed });
      }
    };

    const checkCollapsed = (currentYScrollPosition) => {
      const isOnTop = currentYScrollPosition <= (params?.headerHeight || 0);
      const deltaY = lastYScrollPosition - currentYScrollPosition;
      const isFastMove = deltaY > (params?.fastMoveScrollDelta || 0);
      const direction = deltaY > 0 ? 'UP' : 'DOWN';

      handleDownDirection({ isOnTop, direction });
      handleUpDirection({ isOnTop, isFastMove, direction });
    };

    const onScrollHandler = throttle(100, () => {
      const currentYScrollPosition = window.scrollY;
      if (headerType === 'mobile') {
        checkCollapsed(currentYScrollPosition);
      }
      lastYScrollPosition = currentYScrollPosition;
    });
    window.addEventListener('scroll', onScrollHandler, false);
  },
};
